import { lazy } from "react";
import { Navigate, Outlet, useRoutes } from "react-router-dom";

import { useAppState } from "./context";
import Auth from "./views/Auth/Index";
import Employee from "./views/Employee";
import Employer from "./views/Employer";
import Profile from "./views/Profile";
import QuestionariesCreateEdit from "./views/Questionaries/addQuestionaries";
import FormQuestionaries from "./views/Questionaries/formQuestionaries";
// import Questionaries from "./views/Questionaries";

// Pages
// const Dashboard = lazy(() => import("./views/Dashboard"));
const UserVerification = lazy(() => import("./views/UserVerification"));
// const UserVerification = lazy(() => import("./views/UserVerification"));
const User = lazy(() => import("./views/User"));
const UserCreateUpdate = lazy(() => import("./views/User/UserCreateUpdate"));
const PagesCreateUpdate = lazy(() => import("./views/Pages/PagesCreateUpdate"));
const Pages = lazy(() => import("./views/Pages"));
const Questionaries = lazy(() => import("./views/Questionaries/index"));
// const MasterQuestions = lazy(() => import("./views/MasterQuestionaries/index"));
// const MasterQuestionsCreateUpdate = lazy(
//   () => import("./views/MasterQuestionaries/addMasterQuestionaries"),
// );
const Contact = lazy(() => import("./views/Contact"));
const SubTags = lazy(() => import("./views/SubTags/index"));
const SubTagsCreateUpdate = lazy(() => import("./views/SubTags/addSubTags"));

const UnAuthorizedAccess = lazy(() => import("./views/UnAuthorizedAccess"));

const ContactDetail = lazy(() => import("./views/ContactDetail/index"));

const EmployerCreateUpdate = lazy(
  () => import("./views/Employer/EmployerCreateUpdate"),
);
const PrivacyPolicy = lazy(() => import("./views/privacypolicy/index"));
const MemberPdfCount = lazy(() => import("./views/MemberPdfCount/index"));

export const PrivateRoute = ({ children }: { children: any }) => {
  const { isLoggedIn } = useAppState("auth");

  return isLoggedIn ? children : <Navigate to="/unauthorized" />;
};
/*
const RouteWrapper = ({ element, role }: { element: any; role: string }) => {
  const basePath = useBasePath();

  const ROLES_ACCESS: any = {
    admin: [
      "/dashboard",
      "/user",
      "/user/create",
      "/user/edit/:id",
      "/questionaries",
      "/questionaries/create",
      "/questionaries/edit/:id",
      "/questionaries/tag",
      "/questionaries/tag/:id",
      "/pages",
      "/pages/create",
      "/pages/edit/:id",
      "/employee",
      "/employer",
      "/employer/create",
      "/employer/edit/:id",
      // "/masterQuestion",
      // "/masterQuestion/create",
      // "/masterQuestion/edit/:id",
      "/subTags",
      "/subTags/create",
      "/subTags/edit/:id",
      "/contactDetails",
    ],
  };

  if (!role) {
    return <Navigate to="/login" state={{ from: basePath }} replace={true} />;
  }

  // create function which match role and pathname with RegExp
  const isAuthorized = ROLES_ACCESS[role].some((path: string) => {
    const regExp = new RegExp(path);

    return regExp.test(basePath);
  });

  return isAuthorized ? element : <Navigate to="/unauthorized" />;
};
*/
const Routing = () => {
  const {
    userData: { role_name },
    isLoggedIn,
  } = useAppState("auth");
  console.log("isLoggedIn => ", isLoggedIn);
  console.log("isLoggedIn => ", role_name);

  const routes = useRoutes([
    {
      path: "/",
      element: isLoggedIn ? (
        <Navigate to="/profile" />
      ) : (
        <Navigate to="/login" />
      ),
    },
    // <Auth type={"1"} />
    // {
    //   path: "/dashboard",
    //   element: <Dashboard />,
    // },
    {
      path: "/privacypolicy",
      element: <PrivacyPolicy />,
    },
    {
      path: "/member",
      element: <MemberPdfCount />,
    },
    {
      path: "/contact",
      element: <Contact />,
    },
    {
      path: "/user-verification/:id",
      element: <UserVerification />,
    },
    {
      path: "/",
      // element: <RouteWrapper element={<Outlet />} role={toLower(role_name)} />,
      element: (
        <PrivateRoute>
          <Outlet />
        </PrivateRoute>
      ),
      children: [
        { path: "user", element: <User /> },
        { path: "user/create", element: <UserCreateUpdate type={"1"} /> },
        { path: "user/edit/:id", element: <UserCreateUpdate type={"2"} /> },
        { path: "pages", element: <Pages /> },
        { path: "pages/create", element: <PagesCreateUpdate type={"1"} /> },
        { path: "pages/edit/:id", element: <PagesCreateUpdate type={"2"} /> },
        { path: "questionaries", element: <Questionaries /> },
        {
          path: "questionaries/create",
          element: <QuestionariesCreateEdit type={"1"} />,
        },
        {
          path: "questionaries/edit/:id",
          element: <QuestionariesCreateEdit type={"2"} />,
        },
        {
          path: "questionaries/tag",
          element: <FormQuestionaries type={"1"} />,
        },
        {
          path: "questionaries/tag/:id",
          element: <FormQuestionaries type={"2"} />,
        },
        { path: "subTags", element: <SubTags /> },
        { path: "subTags/create", element: <SubTagsCreateUpdate type={"1"} /> },
        {
          path: "subTags/edit/:id",
          element: <SubTagsCreateUpdate type={"2"} />,
        },
        { path: "employee", element: <Employee /> },
        { path: "employer", element: <Employer /> },
        {
          path: "employer/create",
          element: <EmployerCreateUpdate type={"1"} />,
        },
        {
          path: "employer/edit/:id",
          element: <EmployerCreateUpdate type={"2"} />,
        },
        { path: "contactDetails", element: <ContactDetail /> },
      ],
    },
    {
      path: "/profile",
      element: isLoggedIn ? <Profile /> : <Navigate to="/login" />,
    },
    // element: isLoggedIn ? (
    //   <Navigate to="/profile" />
    // ) : (
    //   <Navigate to="/login" />
    // ),
    {
      path: "/forget-password/:token",
      element: <Auth type={"3"} />,
    },
    {
      path: "/login",
      element: isLoggedIn ? <Navigate to="/profile" /> : <Auth type={"1"} />,
    },
    // {
    //   path: "/forgot-password",
    //   element: <Auth type={"2"} />,
    // },
    {
      path: "unauthorized",
      element: <UnAuthorizedAccess />,
    },
    {
      path: "/*",
      // element: <PageNotFound />,
      element: isLoggedIn ? (
        <Navigate to="/profile" />
      ) : (
        <Navigate to="/login" />
      ),
    },
  ]);

  return routes;
};

export default Routing;
